import { IExposedSector } from "./types";

export const SECTOR_EXPOSURE: IExposedSector[] = [
  { type: "101", name: "Materialer", value: 0, icon: "puzzlePieceIcon" },
  { type: "102", name: "Konsumentvarer", value: 0, icon: "shoppingCartIcon" },
  { type: "103", name: "Finans", value: 0, icon: "bankLibraryIcon" },
  { type: "104", name: "Eiendom", value: 0, icon: "modernHouseIcon" },
  { type: "205", name: "Forbruksvarer", value: 0, icon: "shoppingCartIcon" },
  { type: "206", name: "Helsevern", value: 0, icon: "heartIcon" },
  { type: "207", name: "Verktøy", value: 0, icon: "wrenchScrewdriverIcon" },
  { type: "308", name: "Komminkasjon", value: 0, icon: "chatBubbleLeftRightIcon" },
  { type: "309", name: "Olje & Gass", value: 0, icon: "boltIcon" },
  { type: "310", name: "Industri", value: 0, icon: "factoryIndustryIcon" },
  { type: "311", name: "Teknologi", value: 0, icon: "computerDesktopIcon" },
];
